import gql from 'graphql-tag';

const deleteCategory_MUTATION = gql`
  mutation deleteCategory($_id: ID!) {
    deleteCategory(_id: $_id)
  }
`;

export default deleteCategory_MUTATION;
